const ROWS_PER_PAGE_KEY = 'sa_rows_per_page'
const DEFAULT_PER_PAGE = 10

// Server-side cap (simplerest RangeOptions); requests beyond this return HTTP 422. For dashboards use dedicated aggregation endpoints.
export const MAX_PER_PAGE = 100

export const getPerPage = (): number =>
  parseInt(localStorage.getItem(ROWS_PER_PAGE_KEY) || String(DEFAULT_PER_PAGE), 10)
